/* */ 
var createFlow = require('../internal/createFlow');
var flow = createFlow();
module.exports = flow;
